import React from 'react'
import { Badge } from 'antd'
import styles from './MenuCountBadge.module.scss'

interface IMenuCountBadgeProps {
  count: number
  children: React.ReactNode
}

// Бейдж в строке, а не надстрочный: кнопка раздела на телефоне обрезает всё,
// что вылезает за её границы
export const MenuCountBadge: React.FC<IMenuCountBadgeProps> = ({
  count,
  children
}) => {
  return (
    <>
      {children}
      <Badge count={count} size='small' className={styles.badge} />
    </>
  )
}
